export const genderOptions = "genders";
export const languagesOptions = "languages";
export const nationalitiesOptions = "nationalities";
export const privacyOptions = "privacyOptions";
export const blockOptions = "blockReasons";
export const interfaceTexts = "texts";
export const tokenLL = "token";
export const userInfoLL = "userInfo";
export const userPhotoLL = "userPhoto";